import {Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {FormValidationService} from '../../../services/form-validation.service';
import {AuthService} from '../../../services/auth.service';
import {HttpErrorResponse} from '@angular/common/http';
import {Subscription} from 'rxjs/Subscription';
import {CookieService} from 'ngx-cookie';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styles: [`
    app-input-field {
      width: 320px;
    }
    form {
      display: flex;
      flex-direction: column;
    }
    .different-passwords span {
      font-size: 12px;
      color: #FF4F58;
    }
    app-button {
      margin: 10px auto 20px;
    }
    .updated-container {
      display:flex;
      flex-direction: column;
      align-items: center;
    }
    .secondary-title {
      line-height: 25px;
      max-width: 300px;
    }
    
    .updated-container app-button {
      margin: 20px 0 0;
    }
  `]
})
export class UpdatePasswordComponent {
  updated = false;
  submitted = false;
  form: FormGroup;
  token: string;
  error: string;
  showOverlay = false;
  valueChangesSubscription: Subscription;
  httpRequestSubscritpion: Subscription;
  routeParamsSubscription: Subscription;

  constructor(
    private formValidation: FormValidationService,
    private authService: AuthService,
    private cookieService: CookieService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.form = new FormGroup({
      email: new FormControl('', [
        Validators.required,
        Validators.email
      ]),
      password: new FormControl('', Validators.required),
      confirm_password: new FormControl('', Validators.required),
    }, {validators: this.formValidation.comparePasswords});

    this.routeParamsSubscription = this.route.params.subscribe(({token}) => this.token = token);
    this.valueChangesSubscription = this.form.valueChanges.subscribe(() => this.error = '');
  }

  ngOnDestroy() {
    this.routeParamsSubscription.unsubscribe();
    this.valueChangesSubscription.unsubscribe();
  }

  updatePassword() {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.showOverlay = true;
    this.httpRequestSubscritpion = this.authService.updatePassword({
      token: this.token,
      email: this.form.get('email').value,
      password: this.form.get('password').value
    })
      .subscribe(
        data => {
          this.showOverlay = false;
          this.updated = true;
          // this.email = data.email;
          // this.showOverlay = false;
        },
        (error: HttpErrorResponse) => {
          this.showOverlay = true;
          this.error = error.error.message;
          this.showOverlay = false;
        });
  }
  handleLogin() {

  }
}



// WEBPACK FOOTER //
// ./src/app/modules/authentication/update-password/update-password.component.ts